import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pop_tit" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", {
      class: "pop_up_layer",
      style: _normalizeStyle({ display: $setup.state.isShow ? 'block' : 'none' }),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
    }, null, 4), [
      [_vShow, $setup.state.isShow]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "pop_up _terms",
      style: _normalizeStyle({ display: $setup.state.isShow ? 'block' : 'none' })
    }, [
      _createElementVNode("button", {
        class: "close_btn icon_wrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: "img/close_btn2.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString($setup.props.title), 1)
      ]),
      _createElementVNode("div", {
        class: "content_wrap custom_scroll",
        innerHTML: $setup.props.content
      }, null, 8, _hoisted_2)
    ], 4), [
      [_vShow, $setup.state.isShow]
    ])
  ], 64))
}